import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RcFormControlAbstract} from '../rc-form-control-abstract/rc-form-control-abstract';
import {RcTimeService} from '../../../rc-utils/rc-time/rc-time.service';

/**
 * Rc datepicker - currently wrap ngx bootstrap datepicker
 *
 * @example
 * <lib-rc-datepicker placeholder="myPlaceHolder" control="dateControl" valueChangedCallback="valuChanged($event)"></lib-rc-datepicker>
 */
@Component({
    selector: 'lib-rc-date-range-picker',
    template: `<div class="rc-date-range-picker-wrapper" [ngClass]="{'has-open-button': hasOpenButton}">
    <input type="text"
           [placeholder]="placeholder"
           class="form-control"
           [minDate]="_minDate"
           [maxDate]="_maxDate"
           [(ngModel)]="initialStateValue"
           #dp="bsDaterangepicker"
           [bsValue]="initialStateValue"
           [attr.disabled]="_disabled"
           attr.aria-label="{{ariaLabel}}"
           attr.aria-describedby="{{getAriaDescribedBy()}}"
           [bsConfig]="datePickerConfig"
           (bsValueChange)="onValueChange($event)"
           bsDaterangepicker
    >
    <ng-container *ngIf="hasOpenButton">
        <button id="rc-datepicker-toggle-button-{{elementId}}" class="rc-date-range-picker-toggle-button" [ngClass]="{'is-open': dp.isOpen}" (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen">
            <ng-content select="[openButtonContent]"></ng-content>
        </button>
    </ng-container>
</div>
<div role="alert" id="{{errorElementId}}" class="invalid-feedback-message" *ngIf="errorMsg">{{ errorMsg }}</div>
`,
    styles: [`.rc-date-range-picker-wrapper.has-open-button{display:flex;flex-direction:row}.rc-date-range-picker-wrapper.has-open-button .rc-date-range-picker-toggle-button{border:none;background-color:transparent;cursor:pointer}`]
})
export class RcDateRangePickerComponent extends RcFormControlAbstract {

    /**
     * Extra datepicker config
     */
    @Input() config: any = {};

    /**
     * Minimum date
     */
    @Input()
    set minDate(value: Date | string) {
        this._minDate = new Date(value);
    }
    public _minDate: Date;

    private prevValue;

    /**
     * Maximum date
     */
    @Input()
    set maxDate(value: Date | string) {
        this._maxDate = new Date(value);
    }
    public _maxDate: Date;

    /**
     * Placeholder
     */
    @Input() placeholder: string = 'Selected Date';

    /**
     * has open button
     */
    @Input() hasOpenButton: boolean;

    @Output() onDateChange: EventEmitter<any> = new EventEmitter();

    public initialStateValue;
    /**
     * Default config
     */
    public datePickerConfig = {
        rangeInputFormat: 'DD/MM/YYYY'
    };

    constructor(private timeService: RcTimeService) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.datePickerConfig = Object.assign({}, this.datePickerConfig, this.config);
        if (this.control && this.control.value) {
            if (!this.control.value[0] || !this.control.value[1]) {
                throw 'from and to values are required';
            }
            const from = new Date(this.control.value[0]);
            const to = new Date(this.control.value[1]);
            this.initialStateValue = [from, to];
            this.prevValue = this.control.value;
        }
    }

    /**
     * emit an Output function on change
     * @param $event $event
     */
    onValueChange($event: Date): void {
      if (!$event) {
        return;
      }
        const outputDates = [
            this.timeService.formatFromJsDate($event[0]),
            this.timeService.formatFromJsDate($event[1])
        ];
        this.control.setValue(outputDates);

        this.onChange(outputDates);

        if (!this.prevValue || (this.prevValue[0] !== outputDates[0] || this.prevValue[1] !== outputDates[1])) {
            if (this.onDateChange.observers.length) {
                this.onDateChange.emit(this.control.value);
            }
        }
        this.prevValue = outputDates;
    }
}
